module.exports = __webpack_public_path__ + "img/hackenproof_image_presentation.3340f979.png";